<template>
  <draggable
    :list="items"
    tag="tbody"
    :draggable="'.itemDraggable'"
    @end="onSort(items)"
    :style="cssProps"
  >

    <tr
      v-for="(item, index) in items"
      :key="index"
      class="itemDraggable"
    >
      <td width="20px">
        <v-icon
          small
          class="page__grab-icon"
        >
          mdi-cursor-move
        </v-icon>
      </td>
      <td width="45px" style="padding:0 0 0 10px;text-align:center;">
        <center>
          <v-checkbox
            v-model="multiSelected"
            :key="item.ID"
            :value="item.ID"
            @change="handleChangeMultiSelect(multiSelected)"
            hide-details
            style="margin:0;"
            :disabled="item.ContentMasterID ? true : false"
          />
        </center>
      </td>
      <td width="50px">
        <v-btn 
          v-if="onShareContent"
          text
          @click="onShareContent(item)"
          color="primary"
          style="padding:0;"
        >
          <v-icon
            small
          >
            mdi-share-variant
          </v-icon>
        </v-btn>
        <share-content-info 
          v-else-if="item.ContentMasterID ? true : false"
          :contentMasterID="item.ContentMasterID"
          contentType="media"
          :contentTypeID="item.WorkspaceContentID"
        />
        <v-btn 
          v-else
          text
          color="primary"
disabled
          style="padding:0;"
        >
          <v-icon
            small
          >
            mdi-share-variant
          </v-icon>
        </v-btn>
      </td>
      <td width="100px" style="padding:0px;">
        <preview
          v-if="item && item.previewConfig"
          :prevHeight="prevHeight"
          :config="item.previewConfig"
          :locale="locale"
        />
        <!--
        <v-img
          v-if="item.Screenshot"
          :src="item.Screenshot"
          style="width: 80px;"
          :style="{ height: prevHeight ? `${prevHeight}px` : null }"
        />
        <a
          v-else
          :href="item.MediaURL"
          target="_blank"
        >
        <v-img
          :src="item.MediaURL"
          style="width: 80px;"
          :style="{ height: prevHeight ? `${prevHeight}px` : null }"
        />
          </a>
        -->
      </td>
      <td>
        <div style="padding:10px;">
          <v-icon
            small 
            style="margin-right: 10px"
          >
            {{ item.Type === 'video' ? 'mdi-video' : 'mdi-image-area' }}
          </v-icon>
          <v-icon
            v-if="item.Hide"
            :color="item.Hide ? '#CCCCCC' : 'green'"
            small 
            style="margin-right: 10px"
          >
            {{ item.Hide ? 'mdi-eye-off' : 'mdi-eye' }}
          </v-icon>
          <!--span>{{ item.Type }}</span-->
          <span v-html="prepareURL(item.URL)"></span>
          <a v-if="item.ContentMasterID ? false : true" @click="onEditItem(item.ID)" style="cursor: pointer;" color="primary"><b>{{ item.Name && item.Name.length > 0 ? item.Name : '...' }}</b></a>
          <b v-else style="cursor: not-allowed;">{{ item.Name && item.Name.length > 0 ? item.Name : '...' }}</b>
          <!--v-tooltip bottom v-if="onCloneItem">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                small
                style="cursor: pointer;margin-left: 20px;"
                @click="onCloneItem(item.ID)"
              >
                mdi-content-copy
              </v-icon>
            </template>
            <span>clonar</span>
          </v-tooltip-->
        </div>
      </td>
      <td width="100px" style="text-align: center;">
        {{ handleConvertTime(item.Time) }}
      </td>
      <td style="text-align:center;width:30px;">
        <v-tooltip bottom v-if="onCloneItem">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              style="cursor: pointer;margin-left: 0px;"
              @click="onCloneItem(item.ID)"
              :disabled="item.ContentMasterID ? true : false"
            >
              mdi-content-copy
            </v-icon>
          </template>
          <span>clonar</span>
        </v-tooltip>
      </td>
      <td style="text-align:left;">
        <availability-info :item="item" :locale="locale" />
      </td>
      <td style="text-align:center;width:30px;">
        <availability-icon :item="item.Status" />
      </td>
      <!--td style="text-align:right;">
        <v-icon
          v-if="onEditItem"
          small
          class="mr-2"
          @click="onEditItem(item.ID)"
        >
          mdi-pencil
        </v-icon>
        <delete-item
          v-if="onDeleteItem"
          :id="item.ID"
          :onDeleteItem="onDeleteItem"
          icon="mdi-delete"
          :locale="locale"
        />
      </td-->
    </tr>
  </draggable>
</template>
<script>
  import draggable from 'vuedraggable'
  import utils from '@/services/utils'
  import AvailabilityInfo from './AvailabilityInfo'
  import AvailabilityIcon from './AvailabilityIcon'
  import ShareContentInfo from './ShareContentInfo'
  import Preview from './Preview'
  export default{
    components: {
      draggable,
      AvailabilityInfo,
      AvailabilityIcon,
      Preview,
      ShareContentInfo,
    },
    props: {
      contentID:{
        type: String,
        default: null,
      },
      items: {
        type: Array,
        required: true,
      },
      onDeleteItem: {
        type: Function,
        default: null,
      },
      onSort: {
        type: Function,
        default: null,
      },
      onEditItem: {
        type: Function,
        default: null,
      },
      onCloneItem: {
        type: Function,
        default: null,
      },
      locale: {
        type: String,
        required: true,
      },
      prevHeight: {
        type: Number,
        default: null,
      },
      onChangeMultiSelect: {
        type: Function,
        default: null,
      },
      clearMultiSelect: {
        type: String,
        default: null,
      },
      onShareContent: {
        type: Function,
        default: null,
      },
    },
    data: () => ({
      multiSelected: [],
    }),
    computed: {
      cssProps () {
        return {
          '--secondary-color': this.$vuetify.theme.themes.light.primary.substring(0, 8).concat('0D')
        }
      },
    },
    watch: {
      clearMultiSelect () {
        this.multiSelected = []
        this.onChangeMultiSelect ([])
      },
      contentID () {
        this.multiSelected = []
        this.onChangeMultiSelect ([])
      },
    },
    mounted () {
      this.multiSelected = []
      this.onChangeMultiSelect ([])
    },
    methods: {
      prepareURL (v) {
        if (!v) return
        else {
          const limit = 50
          if (v.length > limit) return `<br />${v.substring(0, limit)}...`
          else return `<br />${v}`
        }
      },
      handleConvertTime (v) {
        return utils.convertTime(v)
      },
      handleChangeMultiSelect (v) {
        this.onChangeMultiSelect (v)
      },
    },
  }
</script>
<style scoped>
.itemDraggable {
  width: 100%;
}
.itemDraggable td{
  border: 0.5px solid white !important;
  /*border-bottom: 1px solid #fcf9f9 !important;*/
}
.itemDraggable:nth-child(odd){
  background: #f6f5f2;
  background_: #fcf9f9;
}
.itemDraggable:nth-child(even){
  _background: #f5f0e7;
  background: var(--secondary-color);
  background_: white;
}
.v-data-table-header {
  background-color: red;
}
</style>

